"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagMZ = function FlagMZ(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6-32.55H-193v-82.39a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#5aa587"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V56.91H216.6V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "90.45",
    width: "409.6",
    height: "89.44",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "82.51",
    width: "409.6",
    height: "11.15",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "176.69",
    width: "409.6",
    height: "11.15",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-190.4,144.65-28.12,15.84a4.68,4.68,0,0,0,0-7.32L-190.4-120.29a7,7,0,0,0-2.6,5.35V139.3a7,7,0,0,0,2.6,5.35Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-127.55-33.76l10.32,31,32.64.25A1.9,1.9,0,0,1-83.48.88l-26.25,19.38,9.84,31.12a1.9,1.9,0,0,1-2.92,2.11l-26.54-19-26.55,19a1.9,1.9,0,0,1-2.92-2.11L-149,20.26-175.22.88a1.9,1.9,0,0,1,1.11-3.43l32.63-.25,10.32-31a1.9,1.9,0,0,1,3.61,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-131.24,23.74l-2.56,2.56h-21.34l5.83-21.37,2.38-1.19-3.82,19.06a.8.8,0,0,0,.17.66.74.74,0,0,0,.59.28Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-126.13,27.29a5.38,5.38,0,0,1-3.22,1.08,5.38,5.38,0,0,1-3.22-1.08l3.22-3.22Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-103.56,26.3H-124.9l-2.55-2.56h18.74a.74.74,0,0,0,.59-.28.8.8,0,0,0,.17-.66l-3.82-19.06,2.38,1.19Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-109.66,22.17h-18.91V2.68c3.17-2.68,11.51-.85,15,.25Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-130.13,2.68V22.17H-149l3.85-19.24c3.54-1.1,11.89-2.93,15.05-.25Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-101.77,26.89-108,4.18a.79.79,0,0,0-.41-.49l-4.13-2.06s0,0-.06,0,0,0,0,0c-.5-.17-12-3.9-16.76-.25-4.81-3.65-16.25.08-16.75.25l0,0a.08.08,0,0,0-.07,0l-4.13,2.06a.83.83,0,0,0-.41.49l-6.18,22.71a.8.8,0,0,0,.12.67.84.84,0,0,0,.63.31h21.92a7,7,0,0,0,4.9,2.07,7,7,0,0,0,4.9-2.07h21.92a.84.84,0,0,0,.63-.31.8.8,0,0,0,.13-.67Zm-26.8-24.21c3.17-2.68,11.51-.85,15,.25l3.85,19.24h-18.9Zm-16.61.25c3.54-1.1,11.89-2.93,15.05-.25V22.17H-149Zm-10,23.37,5.83-21.37,2.38-1.19-3.82,19.06a.79.79,0,0,0,.17.66.74.74,0,0,0,.59.28h18.75l-2.56,2.56Zm25.79,2.07a5.38,5.38,0,0,1-3.22-1.08l3.22-3.22,3.22,3.22a5.36,5.36,0,0,1-3.22,1.08Zm4.45-2.07-2.55-2.56h18.74a.74.74,0,0,0,.59-.28.8.8,0,0,0,.17-.66l-3.82-19.06,2.38,1.19,5.83,21.37Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-109.77-17.77a2,2,0,0,1-2.57-.23l-1-1v2.55l-6.38,6.37h-2.55L-132.5.08h-2.56l-19.6,19.6a1.81,1.81,0,0,0-.43,1.85l.92,2.77L-158,28.12h-2.55l-7.79,7.79a1.61,1.61,0,0,0,0,2.26l5.14,5.14a1.8,1.8,0,0,0,2.64-.1l11.49-13.82,1.27-3.82,2.55-2.55,5.1,7.65,3.83-3.83-4.09-6.11,1-1a2.53,2.53,0,0,0,0-3.58l-.76-.76.72-.71c5.44,4.66,12,5.86,18.19,3.2l-2.13-5c-5.14,2.2-9.34.36-12.26-2L-124.86.08-125.28-2l3-3h2.56l19.12-19.13Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-147.8-20.32l-2.55,2.55a1.81,1.81,0,0,0,0,2.55l.42.43-4.24.85L-165.65-2.47l6.38,6.37L-147.8-7.57l.85-4.25,1.7,1.7L-144-11.4-101.57,31-99,28.46l-42.4-42.4,1.28-1.28-5.1-5.1a1.81,1.81,0,0,0-2.55,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagMZ;
exports["default"] = _default;